import React, { useState, useCallback } from 'react';
import {
  StyledModal,
  ModalTitle,
  ModalDescription,
  ModalContent,
  FormRow,
  FormField,
  Label,
  Required,
  StyledSelect,
  StyledInput,
  DragDropZone,
  FileInput,
  UploadContent,
  UploadCenter,
  IconWrapper,
  TextWrapper,
  UploadTitle,
  UploadText,
  UploadHint,
  FileDisplay,
  FileItem,
  FileInfo,
  FileName,
  FileSize,
  RemoveButton,
  ButtonGroup,
  CancelButton,
  PrimaryButton,
} from './HybridMailStyles';
import { Icon, Input, Select } from 'antd';
import { withTranslation } from 'react-i18next';
import { HYBRID_MAIL_ROOM } from './TranslationValue';


const NAMESPACES = ['HYBRID_MAIL_ROOM', 'INSERT_NAMESPACES', 'HYBRID_MAIL'];
const { Option } = Select;

const SendLettersModal = ({ visible, setHybridModal, handleOnSubmit, t }) => {
  const [jobName, setJobName] = useState('');
  const [splitCriteria, setSplitCriteria] = useState('address');
  const [pageCount, setPageCount] = useState('1');
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = useCallback(e => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback(e => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback(e => {
    e.preventDefault();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files).filter(
      file =>
        file.type === 'application/pdf' ||
        file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.type === 'application/msword',
    );

    if (files.length > 0) {
      setUploadedFile(files[0]);
    }
  }, []);

  const handleFileSelect = useCallback(e => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      if (
        file.type === 'application/pdf' ||
        file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.type === 'application/msword'
      ) {
        setUploadedFile(file);
      }
    }
    e.target.value = '';
  }, []);

  const removeFile = useCallback(() => {
    setUploadedFile(null);
  }, []);

  const handleSubmit = () => {
    handleOnSubmit({
      batchName: jobName,
      splitOnCriteria:splitCriteria,
      pageCount: splitCriteria === 'pageCount' ? pageCount : null,
      file: uploadedFile,
    });
  };

  const enableProceed = jobName?.trim() !== '' && splitCriteria?.trim() !== '' && uploadedFile && ( splitCriteria === 'address' || (splitCriteria === 'pageCount' && pageCount) );

  return (
    <StyledModal
      visible={visible}
      onCancel={() => setHybridModal(false)}
      centered
      closable={true}
      footer={null}
      width="550px"
      title={
        <>
          <ModalTitle>
            {t(HYBRID_MAIL_ROOM.SEND_LETTERS_TEXT.key, HYBRID_MAIL_ROOM.SEND_LETTERS_TEXT.value)}
          </ModalTitle>
          <ModalDescription>
            {t(
              HYBRID_MAIL_ROOM.HYBRID_MAIL_TITLE_DES.key,
              HYBRID_MAIL_ROOM.HYBRID_MAIL_TITLE_DES.value,
            )}
          </ModalDescription>
        </>
      }
    >
      <ModalContent>
          <div>
            <Label>
              {t(HYBRID_MAIL_ROOM.HYBRID_JOB_NAME.key, HYBRID_MAIL_ROOM.HYBRID_JOB_NAME.value)}{' '}
              <Required>*</Required>
            </Label>
            <Input
              placeholder={t(HYBRID_MAIL_ROOM.JOB_NAME_PLACEHOLDER.key, HYBRID_MAIL_ROOM.JOB_NAME_PLACEHOLDER.value)}
              value={jobName}
              onChange={e => setJobName(e.target.value)}
              size="large"
            />
          </div>
        <FormRow>
          <FormField>
            <Label htmlFor="split-criteria">
              {t(
                HYBRID_MAIL_ROOM.SPLIT_CRITERIA_LABEL.key,
                HYBRID_MAIL_ROOM.SPLIT_CRITERIA_LABEL.value,
              )}
            </Label>
            <StyledSelect id="split-criteria" value={splitCriteria} onChange={setSplitCriteria}>
              <Option value="address">
                {t(
                  HYBRID_MAIL_ROOM.SPLIT_CRITERIA_ADDRESS.key,
                  HYBRID_MAIL_ROOM.SPLIT_CRITERIA_ADDRESS.value,
                )}
              </Option>
              <Option value="pageCount">
                {t(
                  HYBRID_MAIL_ROOM.SPLIT_CRITERIA_PAGE.key,
                  HYBRID_MAIL_ROOM.SPLIT_CRITERIA_PAGE.value,
                )}
              </Option>
            </StyledSelect>
          </FormField>

          <FormField>
            <Label htmlFor="page-count">
              {t(HYBRID_MAIL_ROOM.PAGE_COUNT_LABEL.key, HYBRID_MAIL_ROOM.PAGE_COUNT_LABEL.value)}{' '}
              {splitCriteria === 'pageCount' && <Required>*</Required>}
            </Label>
            <Input
              id="page-count"
              type="number"
              min={1}
              placeholder={t(HYBRID_MAIL_ROOM.PAGE_COUNT_PLACEHOLDER.key, HYBRID_MAIL_ROOM.PAGE_COUNT_PLACEHOLDER.value)}
              value={pageCount}
              onChange={e => setPageCount(e.target.value)}
              disabled={splitCriteria !== 'pageCount'}
              size="large"
            />
          </FormField>
        </FormRow>

        <div>
          <DragDropZone
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            $isDragging={isDragging}
          >
            <FileInput
              type="file"
              id="file-upload"
              accept=".pdf,.doc,.docx"
              onChange={handleFileSelect}
            />

            <UploadContent>
              <UploadCenter>
                <IconWrapper>
                  <Icon type="upload" style={{ fontSize: 48, color: '#9CA3AF' }} />
                </IconWrapper>

                <TextWrapper>
                  <UploadTitle>
                    {t(HYBRID_MAIL_ROOM.DRAG_AND_DROP.key, HYBRID_MAIL_ROOM.DRAG_AND_DROP.value)}
                  </UploadTitle>
                  <UploadText>
                    {t(
                      HYBRID_MAIL_ROOM.TO_SEND_LETTERS.key,
                      HYBRID_MAIL_ROOM.TO_SEND_LETTERS.value,
                    )}
                  </UploadText>
                  <UploadHint>
                    {t(
                      HYBRID_MAIL_ROOM.SUPPORTED_FORMATS.key,
                      HYBRID_MAIL_ROOM.SUPPORTED_FORMATS.value,
                    )}
                  </UploadHint>
                </TextWrapper>
              </UploadCenter>

              {uploadedFile && (
                <FileDisplay>
                  <FileItem>
                    <FileInfo>
                      <Icon type="file-text" style={{ fontSize: 16, color: '#3B82F6', flexShrink: 0 }} />
                      <FileName>{uploadedFile.name}</FileName>
                      <FileSize>({(uploadedFile.size / 1024).toFixed(1)} KB)</FileSize>
                    </FileInfo>
                    <RemoveButton
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        removeFile();
                      }}
                    >
                      <Icon type="close" style={{ fontSize: 16, color: '#EF4444' }} />
                    </RemoveButton>
                  </FileItem>
                </FileDisplay>
              )}
            </UploadContent>
          </DragDropZone>
        </div>

        <ButtonGroup>
          <CancelButton onClick={() => setHybridModal(false)}>
            {t(HYBRID_MAIL_ROOM.CANCEL_BUTTON.key, HYBRID_MAIL_ROOM.CANCEL_BUTTON.value)}
          </CancelButton>
          <PrimaryButton type="primary" onClick={handleSubmit} disabled={!enableProceed}>
            {t(HYBRID_MAIL_ROOM.PROCEED_BUTTON.key, HYBRID_MAIL_ROOM.PROCEED_BUTTON.value)}
          </PrimaryButton>
        </ButtonGroup>
      </ModalContent>
    </StyledModal>
  );
};

export default withTranslation(NAMESPACES)(SendLettersModal);
